// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.applications {
  width: 260px;
}
.applications .mat-card,
.applications .mat-mdc-card {
  padding: 0;
}
.applications .mat-card .mat-mdc-button,
.applications .mat-card [mat-button],
.applications .mat-mdc-card .mat-mdc-button,
.applications .mat-mdc-card [mat-button] {
  height: 100%;
  line-height: 1.7;
  font-weight: 400;
  width: 100%;
  border-radius: 0;
}
.applications .mat-card .mat-mdc-button .mdc-button__label,
.applications .mat-card [mat-button] .mdc-button__label,
.applications .mat-mdc-card .mat-mdc-button .mdc-button__label,
.applications .mat-mdc-card [mat-button] .mdc-button__label {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.applications .mat-card .mat-mdc-button .mdc-button__label .mat-icon,
.applications .mat-card [mat-button] .mdc-button__label .mat-icon,
.applications .mat-mdc-card .mat-mdc-button .mdc-button__label .mat-icon,
.applications .mat-mdc-card [mat-button] .mdc-button__label .mat-icon {
  padding: 8px;
  color: #fff;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/applications/applications.component.scss"],"names":[],"mappings":"AAGA;EACI,YAAA;AAFJ;AAGI;;EAEI,UAAA;AADR;AAEQ;;;;EAEI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAEZ;AADY;;;;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAMhB;AALgB;;;;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAUpB","sourcesContent":["// ==========================================================================\r\n// Component: Applications.component\r\n// ==========================================================================\r\n.applications{\r\n    width: 260px;\r\n    .mat-card,\r\n    .mat-mdc-card{\r\n        padding: 0;\r\n        .mat-mdc-button,\r\n        [mat-button]{\r\n            height: 100%;\r\n            line-height: 1.7;\r\n            font-weight: 400;\r\n            width: 100%;\r\n            border-radius: 0;\r\n            .mdc-button__label{\r\n                display: flex;\r\n                flex-direction: column;\r\n                align-items: center;\r\n                .mat-icon{\r\n                    padding: 8px;\r\n                    color: #fff;\r\n                    border-radius: 4px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
